// Estilos padrao do documento, do Guia de Formatacao da casa. Sao usados
// enquanto o backend nao devolve estilos e servem de base para a carga
// inicial da tabela document_styles.
//
// Campos: key, name, type ("paragraph" | "character"), element ("p", "h1",
// "h2", "h3" ou "blockquote", so paragrafo), fontFamily, fontSize, bold,
// italic, uppercase, color, align, spaceBefore/spaceAfter (pt),
// lineHeight, indentLeft/firstLine (cm), system (nao pode ser excluido).

// Formato base do corpo do texto: o que nao muda em relacao a isto nao vai
// para o HTML (fica com o padrao do editor e dos documentos).
export const BASE_FORMAT = {
    fontFamily: null,
    fontSize: "11pt",
    bold: false,
    italic: false,
    uppercase: false,
    color: null,
    align: "justify",
    spaceBefore: 0,
    spaceAfter: 8,
    lineHeight: "1.15",
    indentLeft: 0,
    firstLine: 0,
};

const paragraph = (fields) => ({ ...BASE_FORMAT, type: "paragraph", element: "p", system: true, active: true, ...fields });
const character = (fields) => ({ ...BASE_FORMAT, type: "character", element: null, align: null, spaceAfter: null, lineHeight: null, fontSize: null, system: true, active: true, ...fields });

export const DEFAULT_STYLES = [
    paragraph({ key: "texto-normal", name: "Texto normal" }),
    paragraph({ key: "titulo-1", name: "Título 1", element: "h1", fontSize: "21pt", bold: true, color: "#150030", align: "left", spaceBefore: 14, spaceAfter: 8, lineHeight: "1.2" }),
    paragraph({ key: "titulo-2", name: "Título 2", element: "h2", fontSize: "12pt", bold: true, color: "#150030", align: "left", spaceBefore: 12, spaceAfter: 6, lineHeight: "1.2" }),
    paragraph({ key: "titulo-3", name: "Título 3", element: "h3", fontSize: "11pt", bold: true, align: "left", spaceBefore: 10, spaceAfter: 6, lineHeight: "1.2" }),
    paragraph({ key: "citacao", name: "Citação", element: "blockquote", italic: true, indentLeft: 3, lineHeight: "1.15", spaceBefore: 6, spaceAfter: 6 }),
    paragraph({ key: "ementa", name: "Ementa", fontSize: "10pt", indentLeft: 6, lineHeight: "1", spaceAfter: 12 }),
    paragraph({ key: "destaque", name: "Destaque", bold: true, color: "#7857a8", spaceBefore: 6 }),
    character({ key: "nome-de-parte", name: "Nome de parte", bold: true, uppercase: true }),
    character({ key: "valor", name: "Valor monetário", bold: true }),
    character({ key: "referencia-legal", name: "Referência legal", italic: true }),
];
